import portalClient from '@/services/PortalClient'

export default {
  fetchAll (params = {}, options) {
    const defaultSort = 'createdAt,desc'

    return portalClient.sendRequest(
      'GET',
      'admin/api/v1/referral',
      {
        ...params,
        sort: [].concat(params.sort, defaultSort)
      },
      options
    )
  },
  getReferralCode () {
    return portalClient.sendRequest(
      'GET',
      'admin/api/v1/referral/code'
    )
  },
  sendEmail (data) {
    return portalClient.sendRequest(
      'POST',
      'admin/api/v1/referral/send',
      data
    )
  }
}
